import { render, staticRenderFns } from "./BulkEditContact.vue?vue&type=template&id=98578038&"
import script from "./BulkEditContact.vue?vue&type=script&lang=js&"
export * from "./BulkEditContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports